import initialState from './initialState';

export const types = {
  reset: "reset",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
};
